module.exports = __webpack_public_path__ + "static/media/sass.447ab0cb.png";